import { Component, OnInit, Input } from "@angular/core";
import { Router } from "@angular/router";
import { NavController } from "@ionic/angular";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"]
})
export class HeaderComponent implements OnInit {
  @Input() title: string;
  @Input() color = "primary";
  @Input() isModal = false;

  constructor(public router: Router, private navCtrl: NavController) {}

  ngOnInit() {}

  onaboutus() {
    this.navCtrl.navigateRoot("/about-us");
  }
  onaboutussubmenu1() {
    this.navCtrl.navigateRoot("/about-us-submenu1");
  }
  onaboutussubmenu2() {
    this.navCtrl.navigateRoot("/about-us-submenu2");
  }
  onaboutussubmenu3() {
    this.navCtrl.navigateRoot("/about-us-submenu3");
  }
  onjoinussubmenu1() {
    this.navCtrl.navigateRoot("/contact-us-submenu1");
  }
  onjoinussubmenu2() {
    this.navCtrl.navigateRoot("/contact-us-submenu2");
  }
  onjoinussubmenu3() {
    this.navCtrl.navigateRoot("/contact-us-submenu3");
  }
  onjoinus() {
    this.navCtrl.navigateRoot("/join-us");
  }

  oncontactus() {
    this.navCtrl.navigateRoot("contact-us");
  }
  oncategoriespage() {
    this.navCtrl.navigateRoot("/");
  }
}
